import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45de6464&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=45de6464&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a684d0c3315dfbe7fcb599809449fa35/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de6464",
  null
  
)

export default component.exports